import styled from 'styled-components/macro'
import Box from 'components/shared/Box'

export const SeniorConflictModalWrapper = styled(Box)`
    p:first-child {
        max-width: 80%;
    }
`
